import React from 'react';
import { OutlineButton } from '../outlineButton';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  title: React.ReactNode;
  disable?: boolean;
  onClick?: () => void;
}

export const CsvDownloadButton = React.memo(({ title, disable = false, onClick }: Props) => {
  const { t } = useTranslation();
    return (
      <Tooltip
        placement='top-end'
        title={t(
          'downloadingMayTakeSomeTimeDependingOnTheAmountOfData',
          'データ量に応じてダウンロードに時間がかかる場合がございます。'
        )}
      >
        <div>
          <OutlineButton
            icon={<img src='/images/analysis/icon_dl_csv.svg' alt='CSV' />}
            onClick={onClick}
            disable={disable}
          >
            {title}
          </OutlineButton>
        </div>
      </Tooltip>
    );
});


